<template>
  <div>
    <transition name="router-fade" mode="out-in">
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { userResource } from '@/resource/resource'
  import { getCookie } from '@/common/js/cookies'
  const ERR_OK = 0

  export default {
    name: 'userindex',
    data () {
      return {
      }
    },
    computed: {
      ...mapState([
        'userInfo', 'logined', 'levelInfo', 'creditInfo'
      ])
    },
    created () {
      if (getCookie('isLogined') && !this.logined) {
        this.getUserInfo()
      }
    },
    mounted () {
    },
    methods: {
      // 自动登录获取用户信息
      getUserInfo() {
        userResource.info().then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.AUTO_USERINFO(res.data)
          }
        })
      },
      // 更新vuex状态信息
      ...mapMutations([
        // 'BALANCE',
        'AUTO_USERINFO',
        'LEVELINFO',
        'CREDITINFO'
      ])
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/userindex/userindex.vue